import React from 'react';
import { siteContent } from '../../data/content';
import './Founder.css';

const Founder = () => {
  return (
    <section id="founder" className="founder section">
      <div className="container">
        <div className="founder__content">
          <div className="founder__image">
            <img 
              src="/images/team/valerie-perez.jpg" 
              alt="Valérie Perez" 
              className="founder__photo"
            />
            <div className="founder__image-overlay">
              <div className="founder__quote">
                "Porter la voix des femmes, inspirer des engagements concrets"
              </div>
            </div>
          </div>
          
          <div className="founder__text">
            <div className="founder__header">
              <h2 className="founder__title">{siteContent.founder.title}</h2>
              <h3 className="founder__name">{siteContent.founder.name}</h3>
            </div>
            
            <div className="founder__bio">
              {siteContent.founder.content.map((paragraph, index) => (
                <p key={index} className="founder__paragraph">
                  {paragraph}
                </p>
              ))}
            </div>
            
            <div className="founder__experience">
              <h4 className="founder__experience-title">Expérience médiatique</h4>
              <div className="founder__experience-list">
                {siteContent.founder.experience.map((exp, index) => (
                  <span key={index} className="founder__experience-item">
                    {exp}
                  </span>
                ))}
              </div>
            </div>
            
            <div className="founder__cta">
              <a 
                href="https://valerieperezennouchi.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                Découvrir son parcours
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;

